/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateUpdateKeyValueDto
 */
export interface CreateUpdateKeyValueDto {
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateKeyValueDto
     */
    keyTestId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateKeyValueDto
     */
    taskNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateKeyValueDto
     */
    taskIdent?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateKeyValueDto
     */
    answer?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateUpdateKeyValueDto
     */
    weight?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CreateUpdateKeyValueDto
     */
    param1?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CreateUpdateKeyValueDto
     */
    param2?: number | null;
}

/**
 * Check if a given object implements the CreateUpdateKeyValueDto interface.
 */
export function instanceOfCreateUpdateKeyValueDto(value: object): value is CreateUpdateKeyValueDto {
    return true;
}

export function CreateUpdateKeyValueDtoFromJSON(json: any): CreateUpdateKeyValueDto {
    return CreateUpdateKeyValueDtoFromJSONTyped(json, false);
}

export function CreateUpdateKeyValueDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUpdateKeyValueDto {
    if (json == null) {
        return json;
    }
    return {
        
        'keyTestId': json['keyTestId'] == null ? undefined : json['keyTestId'],
        'taskNumber': json['taskNumber'] == null ? undefined : json['taskNumber'],
        'taskIdent': json['taskIdent'] == null ? undefined : json['taskIdent'],
        'answer': json['answer'] == null ? undefined : json['answer'],
        'weight': json['weight'] == null ? undefined : json['weight'],
        'param1': json['param1'] == null ? undefined : json['param1'],
        'param2': json['param2'] == null ? undefined : json['param2'],
    };
}

export function CreateUpdateKeyValueDtoToJSON(value?: CreateUpdateKeyValueDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'keyTestId': value['keyTestId'],
        'taskNumber': value['taskNumber'],
        'taskIdent': value['taskIdent'],
        'answer': value['answer'],
        'weight': value['weight'],
        'param1': value['param1'],
        'param2': value['param2'],
    };
}

